var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.2083C11.5899 14.2083 14.5 11.2981 14.5 7.70825C14.5 4.1184 11.5899 1.20825 8 1.20825C4.41015 1.20825 1.5 4.1184 1.5 7.70825C1.5 11.2981 4.41015 14.2083 8 14.2083Z",
    stroke: "#595A61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.7083H9.5",
    stroke: "#595A61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.7083V7.20825H7",
    stroke: "#595A61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.95825C7.86193 4.95825 7.75 4.84632 7.75 4.70825C7.75 4.57018 7.86193 4.45825 8 4.45825",
    stroke: "#595A61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.95825C8.13807 4.95825 8.25 4.84632 8.25 4.70825C8.25 4.57018 8.13807 4.45825 8 4.45825",
    stroke: "#595A61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.22ef8df4d064c1eb2c38385c3d9b52cb.svg";
export { ForwardRef as ReactComponent };